"use client";

import { c as _c } from "react/compiler-runtime";
import Link from "@/components/common/link/link";
import SubMenuCard from "../sub-menu-card/sub-menu-card";
import css from "../header-menu.module.scss";
import { NavItem } from "@/sanity/sanity.types";
import { Fragment } from "react";
type NavItemWithKey = {
  _key: string;
} & NavItem;
interface ISubMenuContentProps {
  subMenuActive: NavItemWithKey | null;
  linksPerColumn?: number;
}
const SubMenuContent = props => {
  const $ = _c(10);
  const {
    subMenuActive,
    linksPerColumn
  } = props;
  let t0;
  if ($[0] !== linksPerColumn || $[1] !== subMenuActive) {
    t0 = () => {
      if (!subMenuActive?.children) {
        return [];
      }
      const columns = [];
      subMenuActive.children.forEach((child, index) => {
        const columnIndex = Math.floor(index / (linksPerColumn || 1000));
        if (!columns[columnIndex]) {
          columns[columnIndex] = [];
        }
        columns[columnIndex].push(child);
      });
      return columns;
    };
    $[0] = linksPerColumn;
    $[1] = subMenuActive;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const splitColumnLinks = t0;
  let t1;
  if ($[3] !== splitColumnLinks || $[4] !== subMenuActive) {
    const getGridTemplateColumns = () => {
      const gridArray = ["300px"];
      columnLinks.forEach(() => {
        gridArray.push("1px", "300px");
      });
      return gridArray.join(" ");
    };
    const columnLinks = splitColumnLinks();
    const gridTemplateColumns = getGridTemplateColumns();
    let t2;
    if ($[6] !== gridTemplateColumns) {
      t2 = {
        gridTemplateColumns
      };
      $[6] = gridTemplateColumns;
      $[7] = t2;
    } else {
      t2 = $[7];
    }
    let t3;
    if ($[8] !== subMenuActive) {
      t3 = subMenuActive ? <SubMenuCard data={subMenuActive} /> : <div />;
      $[8] = subMenuActive;
      $[9] = t3;
    } else {
      t3 = $[9];
    }
    t1 = <div className={css.subMenuContent} style={t2}>{t3}{columnLinks.map(_temp2)}</div>;
    $[3] = splitColumnLinks;
    $[4] = subMenuActive;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
};
export default SubMenuContent;
function _temp(child_0, index_0) {
  return <li key={child_0._key ?? index_0} className={css.subMenuListItem}><Link className={css.subMenuLink} href={child_0.link?.href ?? ""} data-cta-id={child_0?.link?.ctaId ?? ""} data-cta-value={child_0?.link?.ctaValue ?? ""} rel={child_0?.link?.nofollow}>{child_0.link?.label}</Link></li>;
}
function _temp2(links, columnIndex_0) {
  return <Fragment key={columnIndex_0}><div className="hidden h-full w-[1px] bg-[#4A4A4A33] xl:block" /><ul className={css.subMenuList}>{links.map(_temp)}</ul></Fragment>;
}